import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import 'leaflet/dist/leaflet.css'
import App from './App.tsx'
import { ProviderSettingsProvider } from './contexts/ProviderSettingsContext'
import { BootstrapProvider } from './contexts/BootstrapContext'

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <BootstrapProvider>
          <ProviderSettingsProvider>
            <App />
          </ProviderSettingsProvider>
        </BootstrapProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
